(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/kambi-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/kambi-widget-definition.js');
"use strict";


class KambiWidgetDefinition {
  constructor(widgetId, tag, targets, conditions) {
    if (!widgetId || !tag || !targets) {
      throw new Error('KambiWidgetDefinition requires widgetId, tag and targets.');
    }
    if (!customElements.get(tag)) {
      throw new Error("No web component with id ".concat(tag, " is registered in CustomElementRegistry."));
    }
    this.widgetId = widgetId;
    this.tag = tag;
    this.targets = targets;
    this.conditions = conditions;
  }
  getDefinition() {
    return {
      widgetId: this.widgetId,
      widgetType: 'web-component',
      tag: this.tag,
      conditions: this.conditions
    };
  }
  getTargets() {
    return this.targets;
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.KambiWidgetDefinition', KambiWidgetDefinition);

 })(window);